import EquipmentDetailsForm from '../../component/Equipments/EquipmentDetailsForm';

const EquipmentRoute = [
  {
    path: '/home/Equipment/details',
    exact: true,
    name: 'equipment-details',
    Component: EquipmentDetailsForm
  },
  {
    path: '/home/Equipment/add',
    exact: true,
    name: 'equipment-details',
    Component: EquipmentDetailsForm
  },
  {
    path: '/home/Equipment/edit',
    exact: true,
    name: 'equipment-details',
    Component: EquipmentDetailsForm
  }
];

export default EquipmentRoute;
